/**
 * MP Header Mobile Cart Text
 * Keeps the mobile "Cart (N)" text in sync with cart updates.
 * Listens for the same 'cart:update' event used by Horizon's cart-icon component.
 */
(function () {
  function updateCartText(count) {
    document.querySelectorAll('.mp-cart-text__count').forEach(function (el) {
      el.textContent = count;
    });
  }

  document.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data;
    if (data && typeof data.itemCount !== 'undefined') {
      updateCartText(data.itemCount);
    }
  });
})();
